module.exports = __webpack_public_path__ + "static/media/vector.9ac7a31d.svg";